import { createFileRoute } from '@tanstack/react-router';
import { SelectionFrame } from '@/components/engagement-requirements/selection-frame';
import { VendorIntelligenceScreen } from '@/components/vendor-intelligence/vendor-intelligence-screen';

/**
 * Engagement → Selection → Vendor intelligence, the bare URL (T-0272;
 * E24-design §2). It lands on the first step not done: the screen reads
 * the evaluation and replaces the URL with that step's. The trailing
 * underscore keeps the step routes out of the Selection route's component
 * (TanStack's non-nested routes), so they draw their own frame.
 */
export const Route = createFileRoute('/engagements/$engagementId/selection_/vendor-intelligence/')({
  component: VendorIntelligenceIndexRoute,
});

function VendorIntelligenceIndexRoute() {
  const { engagementId } = Route.useParams();
  return (
    <SelectionFrame>
      <VendorIntelligenceScreen key={engagementId} engagementId={engagementId} step={null} />
    </SelectionFrame>
  );
}
